import React from "react";
import "../common/styles/Navbar.css";
import { useLocation, useNavigate } from "react-router-dom";
import { NavigationRoutes } from "../../constant/Routes";
import AppHeaderDropDown from "../components/AppHeaderDropdown";
import BackButton from "../common/BackButton";

const HeaderLink = () => {
    if (localStorage.getItem('userEdit')) {
        var editData = JSON.parse(localStorage.getItem('userEdit'))
    }

    const currentLocation = useLocation().pathname;
    var location = getLocation();

    const navigate = useNavigate();

    function getLocation() {
        if (currentLocation === NavigationRoutes.ADMIN_DASHBOARD) {
            return "Dashboard";
        }
        else if (currentLocation === "/admin-dashboard/categories") {
            return "Categories";
        }
        else if (currentLocation.includes("/admin-dashboard/categories/:")) {
            return "Sub Categories";
        }
        else if (currentLocation.includes("/admin-dashboard/attributes/:")) {
            return "Attributes";
        }
        else    if (currentLocation === "/admin-dashboard/plans") {
            return "Plans";
        }
        else    if (currentLocation === "/admin-dashboard/vehicle") {
            return "Vehicles";
        }
        else    if (currentLocation === "/admin-dashboard/content-settings") {
            return "Content Settings";
        }
       else if (currentLocation === "/admin-dashboard/verified-user-listing") {
            return "Verified User's";
        }
       else if (currentLocation === "/admin-dashboard/unverified-user-listing") {
            return "Unverified User's";
        }
       else if (currentLocation.includes("admin-dashboard/user-details/")) {
            return <><BackButton />  User Profile </>;
        }
        else if (currentLocation === "/admin-dashboard/vehicle-make") {
            return "Vehicle Make";
        }
        else if (currentLocation.includes("/admin-dashboard/vehicle-make/:")) {
            return "Vehicle Model"; 
        }
        else if (currentLocation.includes("/admin-dashboard/blog")) {
            return "BLOG"; 
        }
        else if (currentLocation.includes("/admin-dashboard/add-blog")) {
            return "ADD BLOG"; 
        }
        else if (currentLocation.includes("/admin-dashboard/faqs")) {
            return "FAQ"; 
        }
          else if (currentLocation.includes("/admin-dashboard/contact")) {
            return "Contact"; 
        }
          else if (currentLocation.includes("/admin-dashboard/ad-reports")) {
            return "AD REPORTS"; 
        }
        else {
            return "DASHBOARD";
        }
    }

    return (
        <div className="container_navbar">
            <div className="navbar_container_start_side">
                <h3 className="fw-bolder ml-4" style={{ color: "#5A607F" }}>{location}</h3>
            </div>
            <div className="navbar_container_end_side">

            <AppHeaderDropDown />
            </div>
        </div>  
    );
}

export default HeaderLink;
